import React, { useState, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { useCommandeContext } from "../contexts/CommandeContext";
import ServiceCommande from '../services/ServiceCommande';

export default function CommandeRecap() {

	// Initialisation de l'état par défaut
	const [quantiteTotale, setQuantiteTotale] = useState(0);
	const [dureeTotale, setDureeTotale] = useState(0);
	const [montant, setMontant] = useState(0);
	const [displayPrix, setDisplayPrix] = useState(true);
	const [quantiteTotaleOptions, setQuantiteTotaleOptions] = useState(0);
	const [montantOptions, setMontantOptions] = useState(0);
	const [creneau, setCreneau] = useState(undefined);
	const [commune, setCommune] = useState(undefined);
	const [adresse, setAdresse] = useState(undefined);

	// Recupération de la commande et du dispatcher à partir du CommandeContext
	const { commande } = useCommandeContext();

	useEffect(() => {
		setQuantiteTotale(commande.quantiteTotale);
		setDureeTotale(commande.dureeTotale);
		if (commande.creneau !== undefined)
			setMontant(commande.creneau.tarif);
		setQuantiteTotaleOptions(commande.quantiteTotaleOptions);
		setMontantOptions(commande.montantOptions);
		setDisplayPrix(commande.produit !== undefined ? commande.produit.displayPrix : commande.typePaiement !== 'PAIEMENT_INTERVENTION');
		setCreneau(commande.creneau);
		setCommune(commande.commune);
		setAdresse(commande.adresse);
	}, [commande]);

	function updateDetailUnites(commande) {
		let result = '';
		let nbUnites = 0;
		// parcours des unites de travail du produit pour voir si des quantites sont initialisées dans la commande
		commande.produit.unitesTravail.map((ut) => {
			// Récupération de la quantite correspondante dans la commande si elle existe
			let qteTmp = commande[ut.workUnitKey];
			if (qteTmp > 0) {
				result = <> {result} {nbUnites > 0 ? <br /> : ''}  {ut.name} x {qteTmp} </>;
				nbUnites++;
			}
			return 0;
		});
		return result;
	}

	function updateDetailOptions(commande) {
		let result = '';
		let nbOptions = 0;
		// parcours des unites de travail du produit pour voir si des quantites sont initialisées dans la commande
		commande.produit.optionsUnitesTravail.map((ut) => {
			// Récupération de la quantite correspondante dans la commande si elle existe
			let qteTmp = commande[ut.workUnitKey];
			if (qteTmp > 0) {
				result = <> {result} {nbOptions > 0 ? <br /> : ''}  {ut.name} x {qteTmp} </>;
				nbOptions++;
			}
			return 0;
		});
		return result;
	}

	return (

		(quantiteTotale > 0) &&
		<Grid container spacing={2} justifyContent="center">

			<Grid item xs={12}>
				<Typography component="h3" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 26, md: 36, lg: 36 }, fontWeight: 400, textAlign: 'center', my: 2 }}>
					Récapitulatif de ma commande
				</Typography>
			</Grid>

			{(commande.produit !== undefined) &&
				<Grid item xs={12} sm={6}>
					<Typography component="div" align="center" >
						Détail des unités selectionnées :
					</Typography>
					<Typography component="div" align="center" sx={{ fontSize: { xs: 18 }, fontWeight: 600 }}>
						{updateDetailUnites(commande)}
						<br />Total : {quantiteTotale}
						{montant > 0 &&
							<>
								<br /> Durée :  {ServiceCommande.convertMinutesToHoursMinutes(dureeTotale)}
							</>
						}

					</Typography>
				</Grid>
			}

			{montant > 0 && displayPrix  ?
				<Grid item xs={12} sm={6}>
					<Typography component="div" align="center" >
						Montant du créneau selectionné :
					</Typography>
					<Typography component="div" align="center" variant="highlight">
						{montant}<Typography component="span" align="center" variant="currency"> €</Typography>
					</Typography>
				</Grid>
				:
				<Grid item xs={12} sm={6}>
					<Typography component="div" align="center" >
						Durée estimée de l'intervention :
					</Typography>
					<Typography component="div" align="center" variant="highlight">
						{ServiceCommande.convertMinutesToHoursMinutes(dureeTotale)}
					</Typography>
				</Grid>
			}

			{(montantOptions > 0 && commande.produit !== undefined) &&
				<Grid item xs={12} sm={6}>
					<Typography component="div" align="center" >
						Détail des options :
					</Typography>
					<Typography component="div" align="center" sx={{ fontSize: { xs: 18 }, fontWeight: 600 }}>
						{updateDetailOptions(commande)}
						<br />Total : {quantiteTotaleOptions}
					</Typography>
				</Grid>
			}
			{(montantOptions > 0) &&
				<Grid item xs={12} sm={6}>
					<Typography component="div" align="center" >
						Montant des options :
					</Typography>
					<Typography component="div" align="center" variant="highlight">
						{montantOptions}<Typography component="span" align="center" variant="currency"> €</Typography>
					</Typography>
				</Grid>
			}

			{(creneau !== undefined) &&
				<Grid item xs={12} sm={6} >
					<Typography component="div" align="center" >
						Adresse de l'intervention :
					</Typography>
					<Typography component="div" align="center" variant="highlight2" mt={1.5}>
						{adresse}<br />
						{commune.codePostal} {commune.nomCommune}
					</Typography>
				</Grid>
			}
			{(creneau !== undefined) &&
				<Grid item xs={12} sm={6} >
					<Typography component="div" align="center" >
						Créneau de l'intervention :
					</Typography>
					<Typography component="div" align="center" variant="highlight2" mt={1.5}>
						{creneau.dateComplete}<br />
						{creneau.heureRdvDebut} - {creneau.heureRdvFin}
					</Typography>
				</Grid>
			}
		</Grid>
	);
}